
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { bulidUid } from '@/libs/util.js'
import { Getter, Mutation } from 'vuex-class'
@Component
export default class QhhwTable extends Vue {
    //秦皇汉武
    table = {
        data: [],
        column: [
            {
                key: 'qin',
                title: '下注秦金额',
                align: 'center',
                render: (h, params) => {
                    let strzo: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.qin) {
                        if (JSON.parse(params.row.opt_detail).hits.hits.qin.bet) {
                            strzo = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.qin.bet)
                        }
                    } else {
                        strzo = '/'
                    }
                    return h('span', strzo)
                }
            },
            {
                key: 'han',
                title: '下注汉金额',
                align: 'center',
                render: (h, params) => {
                    let strzo: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.han) {
                        if (JSON.parse(params.row.opt_detail).hits.hits.han.bet) {
                            strzo = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.han.bet)
                        }
                    } else {
                        strzo = '/'
                    }
                    return h('span', strzo)
                }
            },
            {
                key: 'mix',
                title: '下注和金额',
                align: 'center',
                render: (h, params) => {
                    let strzo: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.mix) {
                        if (JSON.parse(params.row.opt_detail).hits.hits.mix.bet) {
                            strzo = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.mix.bet)
                        }
                    } else {
                        strzo = '/'
                    }
                    return h('span', strzo)
                }
            },
            // {
            //     key: 'total_bet', title:'是否上庄', align: 'center',
            //     render: (h, params) => {
            //         let str = JSON.parse(params.row.opt_detail).hits.is_banker ? "是" : '否'
            //         return h('span',str)
            //     }
            // },
            {
                key: 'b_dealer',
                title: '牌型(秦)',
                align: 'center',
                render: (h, params) => {
                    let strzo: any
                    let str: any
                    if (JSON.parse(params.row.opt_detail).award_content) {
                        strzo = JSON.parse(params.row.opt_detail).award_content.point.qin.poker || []
                        return h('div', {
                            style: {
                                marginTop: '5PX'
                            },
                            domProps: {
                                innerHTML: strzo.map((x) => {
                                    return "<img style='width:35px;' src=img/poker/" + x + '.png>'
                                })
                            }
                        })
                    } else {
                        return h('span', '/')
                    }
                }
            },
            {
                key: 'b_dealer',
                title: '牌型(汉)',
                align: 'center',
                render: (h, params) => {
                    let strzo: any
                    let str: any
                    if (JSON.parse(params.row.opt_detail).award_content) {
                        strzo = JSON.parse(params.row.opt_detail).award_content.point.han.poker || []
                        return h('div', {
                            style: {
                                marginTop: '5PX'
                            },
                            domProps: {
                                innerHTML: strzo.map((x) => {
                                    return "<img style='width:35px;' src=img/poker/" + x + '.png>'
                                })
                            }
                        })
                    } else {
                        return h('span', '/')
                    }
                }
            },
            {
                key: 'total_win',
                title: '输赢',
                align: 'center',
                render: (h, params) => {
                    let strzo: any
                    if (JSON.parse(params.row.opt_detail).hits.total_win) {
                        strzo = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.total_win)
                    } else {
                        strzo = '/'
                    }
                    return h('span', strzo)
                }
            }
        ]
    }
    @Prop()
    listdata
}
